import {useMemo} from 'react';

import Collapse from '@mui/material/Collapse';

import {useNavigationStore} from '../../../../Stores/navigation';
import {useConfigStore} from '../../../../Stores/config';

import BreadcrumbsWidget from '../../Widgets/Breadcrumbs';
import TitleWidget from '../../Widgets/Title';
import TopPagePicture from '../../Widgets/TopPagePicture'

import LinksTile from '../../Widgets/LinksTile'

import BannerCarousel from '../../../../Components/BannerCarousel';

import './index.scss'

export default function Template(props) {
    const {content, children, config, permits, breadcrumbs} = props

    const {contentLoading} = useNavigationStore()
    // const {configs} = useConfigStore();

    const firstLine = useMemo(() => {
        let result = {};
        config?.firstLine?.map(id => {
            result.order = result.order || [];
            result.order.push(id);
            result.list = result.list || {};
            result.permits = result.permits || {};
            Object.keys(children.list).map(uri => {
                if (children.list[uri]._did === id) {
                    result.list[id] = children.list[uri];
                    result.permits[id] = children.permits[uri];
                }
            })
        })
        return result;
    }, [config, children])
    console.log("firstLine", firstLine)
    const secondLine = useMemo(() => {
        let result = {};
        config?.secondLine?.map(id => {
            result.order = result.order || [];
            result.order.push(id);
            result.list = result.list || {};
            result.permits = result.permits || {};
            Object.keys(children.list).map(uri => {
                if (children.list[uri]._did === id) {
                    result.list[id] = children.list[uri];
                    result.permits[id] = children.permits[uri];
                }
            })
        })
        return result;
    }, [config, children])

    return <div className="MainTemplate">
        <TopPagePicture cutHeightForDesktop image={content.banner} hidden={config?.templateOptions?.topPagePictureHidden}/>

        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {config?.topCarousell && <div className='BannerCarousellWrap'>
            <Collapse in={!contentLoading}>
                <BannerCarousel
                    // className="MainBannerCarousell"
                    animation="slide"
                    autoPlay={false}
                    data={config.topCarousell}
                />
            </Collapse>
        </div>}

        {firstLine && <div className="TileSections"><LinksTile
            spacing={1}
            xs={4} md={4}
            showSkeleton={contentLoading}
            links={firstLine}
        /></div>}

        {config?.middleCarousell && <div className='BannerCarousellWrap'>
            <Collapse in={!contentLoading}>
                <BannerCarousel
                    // className="MainBannerCarousell"
                    animation="slide"
                    autoPlay={false}
                    data={config.middleCarousell}
                />
            </Collapse>
        </div>}

        {secondLine && <div className="TileSections"><LinksTile
            spacing={1}
            xs={4} md={4}
            showSkeleton={contentLoading}
            links={secondLine}
        /></div>}


        {config?.bottomCarousell && <div className='BannerCarousellWrap'>
            <Collapse in={!contentLoading}>
                <BannerCarousel
                    // className="MainBannerCarousell"
                    animation="slide"
                    autoPlay={false}
                    data={config.bottomCarousell}
                />
            </Collapse>
        </div>}

    </div>
}
